import { render, staticRenderFns } from "./ContentElement.vue?vue&type=template&id=026d200c&scoped=true"
import script from "./ContentElement.vue?vue&type=script&lang=js"
export * from "./ContentElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d200c",
  null
  
)

export default component.exports